export const palette = {
  navy: '#0a1e3f',
  navyMid: '#152d54',
  cream: '#fafaf6',
  paper: '#ffffff',
  gold: '#c4a662',
  goldBright: '#dabb7a',
  goldDeep: '#8a6d3d',
  ink: '#0f172a',
  inkSoft: '#475569',
  mute: '#94a3b8',
  line: '#e8e4d8',
  good: '#15803d',
  bad: '#dc2626',
} as const;
